import { useEnabledFlag } from '@wwe-portal/web/components/common/feature-flag';
import { API_ENV } from '@wwe-portal/web/utils/config';
import { useCallback } from 'react';

export const useGetXsollaPaymentWidget = () => {
  const { enabled: liveModeEnabled } = useEnabledFlag('xsolla.paymentLiveMode');

  return useCallback(
    (access_token: string) => {
      const isLiveMode = API_ENV === 'prod' || liveModeEnabled;
      const xsollaUrl = isLiveMode
        ? `https://secure.xsolla.com/paystation3/?access_token=${access_token}`
        : `https://sandbox-secure.xsolla.com/paystation3/?access_token=${access_token}`;
      const options = {
        access_token,
        sandbox: !isLiveMode,
        lightbox: {
          zIndex: 1054,
        },
      };
      return {
        xsollaUrl,
        options,
      };
    },
    [liveModeEnabled]
  );
};
